
import { Resource } from "src/app/core/jsonapi/resource";
import { prop, propObject, required } from "@rxweb/reactive-form-validators";

export class Extension extends Resource {
    public override type = 'extension';

    @prop()
    public exten!: string;     

    @prop()
    public password!: string;      

    @prop()    
    public description!: string;     

    @prop()    
    public userId!: string;   
    
}